import {
  type PositionRepository,
  type PositionModel,
  type GetAllPositionsDTO,
  type CreateOrderDTO,
  UpdatePositionDTO
} from '@trading/core'
import axios from '../axios'

export class PositionApiAxios implements PositionRepository {
  async getAll(dto: GetAllPositionsDTO) {
    return await axios
      .get<{ data: PositionModel[] }>(`account/positions`, {
        params: dto
      })
      .then((resp) => resp.data.data)
      .catch((e) => {
        throw new Error(e)
      })
  }

  async closePosition(id: ID): Promise<void> {
    return await axios
      .post(`account/positions/${id}/close`)
      .then(() => {
      })
      .catch((e) => {
        throw new Error(e.response?.data?.error.message ?? e)
      })
  }

  async doublePosition(position: PositionModel): Promise<void> {
    const dto = this.prepareDoublePositionDto(position)
    await axios
      .post(`trading/orders`, dto, {
        metadataDescription: {
          item: 'Order',
          action: 'Create'
        }
      })
      .catch((e) => {
        throw new Error(e)
      })
  }

  async reversePosition(position: PositionModel): Promise<void> {
    await this.closePosition(position.id)
    const dto = this.prepareReversePositionDto(position)
    await axios
      .post(`trading/orders`, dto, {
        metadataDescription: {
          item: 'Order',
          action: 'Create'
        }
      })
      .catch((e) => {
        throw new Error(e)
      })
  }

  async modifyPosition(position: PositionModel): Promise<void> {
    const dto = this.prepareModifyPositionDto(position)
    await axios
      .patch(`account/positions/${position.id}`, dto, {
        metadataDescription: {
          item: 'Position',
          action: 'Update'
        }
      })
      .catch((e) => {
        throw new Error(e)
      })
  }

  private prepareDoublePositionDto(position: PositionModel): CreateOrderDTO {
    const res: CreateOrderDTO = {
      type: 'MARKET',
      quantity: position.quantity,
      symbol: position.symbol,
      account_id: position.account_id as string,
      leverage: position.leverage,
      post_only: false,
      reduce_only: false,
      side: position.side === 'LONG' ? 'BUY' : 'SELL',
      position_side: position.side,
      time_in_force: 'GTC'
    }

    if (position.sl) res.sl = position.sl.toString()
    if (position.tp) res.tp = position.tp.toString()

    return res
  }

  private prepareReversePositionDto(position: PositionModel): CreateOrderDTO {
    const res: CreateOrderDTO = {
      type: 'MARKET',
      quantity: position.quantity,
      symbol: position.symbol,
      account_id: position.account_id as string,
      leverage: position.leverage,
      post_only: false,
      reduce_only: false,
      // side: position.side === 'LONG' ? 'BUY' : 'SELL',
      side: position.side === 'LONG' ? 'SELL' : 'BUY',
      // position_side: position.side,
      position_side: position.side === 'LONG' ? 'SHORT' : 'LONG',
      time_in_force: 'GTC'
    }

    if (position.sl) res.sl = position.sl.toString()
    if (position.tp) res.tp = position.tp.toString()

    return res
  }

  private prepareModifyPositionDto(position: PositionModel): UpdatePositionDTO {
    const res: UpdatePositionDTO = {}

    res.sl = position.sl ? position.sl.toString() : "0"
    res.tp = position.tp ? position.tp.toString() : "0"

    return res
  }
}
